module.exports = __webpack_public_path__ + "static/media/banner-1.43d58f1f.jpg";